import { graphql } from 'gql';

export const bimWorkOrderChangeOtherDistributionGql = graphql(`
    query bimWorkOrderChangeOtherDistribution($workOrderOtherPriceId: Long, $workOrderChangeOtherPriceId: Long) {
        bimWorkOrderChangeOtherDistribution(
            workOrderOtherPriceId: $workOrderOtherPriceId
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
        ) {
            result
            data {
                contractOtherCost {
                    id
                    contractId
                    name
                    calculatingType
                    calculatingTypeValue
                    chapter
                    section
                    formula
                    status
                    isGlobalOtherCost
                    rationale
                }
                limit {
                    costLimit
                    totalRemainderCost
                    includedCost
                    isSystemCalculation
                }
                objectDistribution {
                    contractObjectId
                    workOrderObjectId
                    workOrderChangeObjectId
                    name
                    isIncluded
                    cost
                    errors
                }
            }
        }
    }
`);

export const bimUpdateWorkOrderChangeOtherDistributionGql = graphql(`
    mutation bimUpdateWorkChangeOrderOtherDistribution(
        $workOrderChangeId: Long!
        $workOrderOtherPriceId: Long
        $workOrderChangeOtherPriceId: Long
        $input: BimWorkOrderChangeOtherDistributionInput!
    ) {
        bimUpdateWorkChangeOrderOtherDistribution(
            workOrderChangeId: $workOrderChangeId
            workOrderOtherPriceId: $workOrderOtherPriceId
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            input: $input
        ) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCalcWorkOrderChangeOtherDistributionGql = graphql(`
    query bimCalcWorkOrderChangeOtherDistribution(
        $workOrderChangeId: Long!
        $workOrderOtherPriceId: Long
        $workOrderChangeOtherPriceId: Long
        $input: BimWorkOrderChangeOtherPriceCalcInput!
    ) {
        bimCalcWorkOrderChangeOtherDistribution(
            workOrderChangeId: $workOrderChangeId
            workOrderOtherPriceId: $workOrderOtherPriceId
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            input: $input
        ) {
            data {
                workOrderObjectId
                workOrderChangeObjectId
                others
                hasErrors
                errors
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
